import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const DayOffTotals = z.object({
    holidays: z.number(),
    sickLeave: z.number(),
    nonWorkingDays: z.number(),
});

export type DayOffTotals = z.infer<typeof DayOffTotals>;
